export var awsuiVisualRefreshFlag = Symbol.for('awsui-visual-refresh-flag');
export var awsuiGlobalFlagsSymbol = Symbol.for('awsui-global-flags');
